const SELECTOR_NEWSLETTER = '[data-newsletter-signup]';


const newsletterForms = document.querySelectorAll<HTMLFormElement>(SELECTOR_NEWSLETTER);

newsletterForms.forEach((form) => {
  const emailInput = form.querySelector<HTMLInputElement>('input[type="email"]');
  const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');

  if (!emailInput || !submitBtn) return;

  submitBtn.disabled = true;

  emailInput.addEventListener('input', () => {
    const value = emailInput.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(value);
    submitBtn.disabled = !isValid;submitBtn.disabled = !isValid;
  });

  form.addEventListener('submit', (e) => {
    if (!emailInput.validity.valid) {
      e.preventDefault();
    }
  });
});